import Button from './Button';
import Image from './Image';
import Search from './Search';
import Select from './Select';
import Table from './Table';
import Input from './Input';
import FileInput from './FileInput';
import RadioInput from './RadioInput';
import TextArea from './TextArea';
import CustomTable from './CustomTable';
import Pagination from './Pagination';
import Badge from './Bages';
import CustomSearch from './CustomSearch';
import CustomImages from './CustomImage'
import LocationBadge from './LocationBadge'
import CommonModal from './CommonModal'
import StatusComponent from "./StatusComponent"
import DatePicker from "./DatePicker"
import AppLoader from "./AppLoader"
import GenerateBarcode from "./GenerateBarcode"
import IntlPhoneField from "./IntlPhoneField"
const atoms = {
    Button,
    Image,
    Search,
    Select,
    Table,
    Input,
    RadioInput,
    TextArea,
    CustomTable,
    Pagination,
    Badge,
    CustomSearch,
    CustomImages,
    LocationBadge,
    CommonModal,
    StatusComponent,
    DatePicker,
    FileInput,
    AppLoader,
    GenerateBarcode,
    IntlPhoneField
}
export default atoms